import {observer} from "mobx-react"
import {ModalDialog, Page, PageContentTitle} from "../../ui"
import {useNavigate} from "react-router"
import {cmsCreateStore, DialogStore, growlStore} from "../../../store"
import {CmsForm, CmsFormData} from "./CmsForm"
import {useState} from "react"

const CmsCreatePage = observer(function CmsCreatePage() {
    const navigate = useNavigate()
    const [cancelDialog] = useState(new DialogStore())

    const {
        name,
        customerNumber,
        addressPostCode,
        addressHouseNumber,
        addressCountry,
        addressAddition,
        addressStreet,
        addressCity,
        active,
        displayName
    } = cmsCreateStore

    const data: CmsFormData = {
        name,
        active,
        displayName,
        customerNumber,
        addressPostCode,
        addressHouseNumber,
        addressAddition,
        addressCity,
        addressCountry,
        addressStreet
    }

    const display = `Neuen Kunden anlegen`

    return <Page
        breadcrumb={[
            {
                link: '/cms',
                label: `Kundenverwaltung`
            },
            {
                link: `/cms/create`,
                label: display
            }
        ]}
    >
        <ModalDialog
            store={cancelDialog}
            actions={[
                {
                    label: "Abbrechen",
                    execute: async function () {
                        cancelDialog.dialogOpen = false
                    },
                    className: 'is-primary is-rounded is-small'
                },
                {
                    label: "Verwerfen",
                    execute: async function () {
                        cmsCreateStore.reset()
                        cancelDialog.dialogOpen = false
                        navigate('/cms')
                    },
                    className: 'is-rounded is-small'
                }
            ]}
            title={"Änderungen verwerfen?"}
        >
            Sind Sie sich sicher, dass Sie die Änderungen verwerfen wollen?
        </ModalDialog>
        <PageContentTitle
            actions={[
                {
                    label: 'Speichern',
                    cls: `is-primary ${cmsCreateStore.creating ? 'is-loading' : ''}`,
                    disabled: !(cmsCreateStore.dirty && cmsCreateStore.valid),
                    action: async () => {
                        const id = await cmsCreateStore.create()
                        if (!id) {
                            return
                        }
                        cmsCreateStore.reset()
                        growlStore.add({
                            message: 'Der Kunde wurde erfolgreich hinzugefügt',
                            autoclose: true,
                            closable: true
                        })
                        navigate(`/cms/${id}`)
                    }
                },
                {
                    label: 'Verwerfen',
                    cls: 'is-primary is-outlined',
                    disabled: cmsCreateStore.creating || !cmsCreateStore.dirty,
                    action: async () => {
                        cancelDialog.dialogOpen = true
                    }
                },
            ]}
        >{display}</PageContentTitle>
        <CmsForm
            mode={'create'}
            saving={cmsCreateStore.creating}
            data={data}
            validate={async () => {
                await cmsCreateStore.validate()
            }}
            onChange={val => {
                const {
                    name,
                    active,
                    displayName,
                    customerNumber,
                    addressPostCode,
                    addressHouseNumber,
                    addressAddition,
                    addressCity,
                    addressCountry,
                    addressStreet
                } = val
                cmsCreateStore.name = name
                cmsCreateStore.active = active
                cmsCreateStore.displayName = displayName
                cmsCreateStore.customerNumber = customerNumber
                cmsCreateStore.addressPostCode = addressPostCode
                cmsCreateStore.addressHouseNumber = addressHouseNumber
                cmsCreateStore.addressAddition = addressAddition
                cmsCreateStore.addressCity = addressCity
                cmsCreateStore.addressCountry = addressCountry
                cmsCreateStore.addressStreet = addressStreet

            }}/>
    </Page>
})

export {
    CmsCreatePage
}
